/* eslint-disable quotes */
export default {
  app: 'App',
  domain_host_name: 'Domain(hostname)',
  effective_time: 'Effective Time',
  expiry_time: 'Expiry Time',
  application_time: 'Application Time',
  last_access_time: 'LastAccess Time',
  reload: 'Reload',
  online_record: 'Online Record',
  domain: 'Domain',
  white_list: 'Whitelist',
  env_create: 'Create Env',
  studio_name: 'studio',
  studio_name_uppercase: 'Studio',
  studioid: 'StudioID',
  game_uppercase: 'Game',
  gameid: 'GameID',
  game_key: 'GameKey',
  game_name: 'GameName',
  game_code: 'CodeName',
  user_name: 'User Name',
  user_space_type: 'User Type',
  version: 'Version',
  content: 'Content',
  zh_news_name: 'Chinese Name',
  en_news_name: 'English Name',
  please_enter_news_name: 'Enter the notification Name',
  news_range: 'Range',
  please_enter_news_range: 'select the range',
  cnContent: 'Chinese Content',
  enContent: 'English Content',
  need_update: 'Need Update',
  title_id: 'Title ID',
  title_name: 'Title Name',
  title_name_lowercase: 'Title name',
  region_env_name: 'Region (Env name)',
  studio_name_studio_id: 'Studio Name (Studio ID)',
  env_id: 'Env Id',
  env_guid: 'Env Guid',
  env_name: 'Env Name',
  admin_env_type: 'Type',
  system: 'System',
  downLoad: 'DownLoad',
  engine: 'Engine',
  ioa: 'IOA',
  tag: 'Tag',
  service_name: 'Service Name',
  service_version: 'Service Version',
  server_url: 'Server URL',
  gate_address: 'Gate Address',
  realm_url: 'Realm URL',
  objectid: 'ObjectID',
  business: 'Business',
  type: 'type',
  user_type: 'UserType',
  type_uppercase: 'Download Type',
  description: 'Description',
  zh_description: 'Chinese Description',
  en_description: 'English Description',
  properties: 'Properties',
  doc_link: 'DocLink',
  doc: 'Doc',
  // g6_type: 'G6',
  // currency_type: 'Currency',
  // gcloud_type: 'GCloud',
  gos: 'Gos',
  support_type: 'SupportType',
  // iframe_type: 'Iframe',
  // jump_type: 'Jump',
  // multiplayer_type: 'Multiplayer',
  // social_type: 'Social',
  // economy_type: 'Economy',
  // engage_type: 'Engage',
  // analytics_type: 'Analytics',
  // ue_plugin_type: 'UE Plugin',
  // unity_plugin_type: 'Unity Plugin',
  // cpp_type: 'C++',
  freeze: 'Freeze',
  online: 'Online',

  // download_object_client_type: 'Client',
  // download_object_server_type: 'Server',
  // download_object_sample_type: 'Sample',
  // download_object_tools_type: 'Tools',

  // platform_android_type: 'Android',
  // platform_ios_type: 'iOS',
  // platform_windows_type: 'Windows',
  // platform_mac_type: 'Mac',
  // platform_ps4_type: 'PS4',
  // platform_ps5_type: 'PS5',
  // platform_xsx_type: 'XSX',
  // platform_switch_type: 'Switch',

  ue_version: 'UE Version',
  unity_version: 'Unity Version',
  platforms: 'Platforms',
  ps_sdk_version: 'PS SDK Version',
  gdk_version: 'GDK Version',
  package: 'Package',

  retry: 'Retry',
  founder_id: 'Founder ID',
  founder_name: 'Founder Name',
  parent_sort: 'ParentSort',
  parent_name: 'ParentName',
  icon_url: 'IconURL',
  pic: 'Pic',
  release_sort: 'ReleaseSort',
  service_path: 'ServicePath',
  subservice_names: '子服务',
  unique_name: 'UniqueName',
  create_service: 'Create Service',
  edit_service: 'Edit Service',
  del_service: 'Delete Service',
  create_download: 'Create Download',
  delete_download: 'Delete Download',
  edit_download: 'Edit Download',
  create_version: 'Create Version',
  delete_version: 'Delete Version',
  edit_version: 'Edit Version',
  json_config: 'JsonConfig',
  config: 'Config',
  all_services: 'All Services',
  applicant: 'Applicant',
  sync_value: 'SyncValue',
  system_type: 'SystemType',
  receiver: 'Receiver',
  default_all: 'Default all',
  please_select_type: 'Please select a type!',
  please_select_receiver: 'Please select receiver(s)',
  please_select_system_type: 'Please select a systemType',
  please_input_your_title: 'Please input your title!',
  please_input_a_title: 'Please input a title',
  password_valid_time: 'Password Valid Time',
  the_field_is_required: 'The field{{suffix}} {{keyTips}} is required',
  the_value_of_field_wrong: 'The value of field [{{key}}] is wrong.',
  the_field_in_not_expected:
    'The Field [{{key}}] in Common Config is not an expected.',
  copyright_config_error: 'CopyRight Config Error.',
  game_config_error: 'GameConfig Config Error.',
  document_config_error: 'Document Config Error.',
  legal_terms_config_error: 'LegalTerms Config Error.',
  duplicate_configuration_items: '[{{key}}] is duplicate configuration items.',
  is_not_expected_field: '[{{key}}] is not an expected field.',
  create_success: 'Created successfully.',
  create_fail: 'Failed to create',
  edit_success: 'Update successfully.',
  del_success: 'Successfully deleted.',
  error_update: 'Failed to update.',
  error_delete: 'Failed to delete.',
  json_config_error: 'Json Config error.',
  validate_error: 'Validate Error.',
  del_confirm_h4:
    'You will delete the {{domain}} configuration, and the deleted configuration cannot be restored! Are you absolutely sure? ',
  del_confirm_desc_text1:
    'This operation may cause data loss. To reduce unnecessary losses,please confirm your operation again. Please enter ',
  del_confirm_desc_text2: ' to confirm or cancel this operation.',
  title_warn_select: 'please select a Title!',
  studio_warn_select: 'please select a Studio!',
  region_warn_select: 'please select a Region!',
  please_input_name: 'Please Input a Name!',
  please_enter_name: 'Please enter a name',
  please_enter_version: 'Please enter versions',
  please_enter_download_name: 'Enter the download name',
  please_enter_download_version: 'Enter the download version',
  please_select_status: 'Please Select a Status!',
  please_select_business: 'Please Select a Business!',
  please_select_support_type: 'Please Select a SupportType!',
  please_select_parent_name: 'Please Select a ParentName!',
  please_select_one_service: 'Please select at least one service.',
  select_a_parent_name: 'Select a parentName',
  please_enter_unique_name: 'Please enter UniqueName',
  select_studio: 'Select studio',
  select_title: 'Select title',
  select_env: 'Select env',
  select_region: 'Select region',
  env_create_success: 'Environment created successfully.',
  env_create_fail: 'Environment created failed!',
  notify_success: 'Notify successfully.',
  notify_fail: 'Failed to notify.',
  select_env_and_service: 'Select Environment & Service',
  notify_om: 'Notify O&M',
  notify: 'Notify',
  active_time: 'Active Time',
  expired_time: 'Expired Time',
  discard_changes: 'Discard Changes',
  sure_discard_changes: 'Are you sure you want to discard the changes?',
  please_select_applicant: 'Please select applicant!',
  please_enter_password_valid_time: 'Please enter password valid time!',
  please_select_download_type: 'Select the download type',
  please_select_download_name: 'Select the download name',
  please_enter_desc: 'Enter the download description',
  please_enter_zh_desc: 'Enter the download chinese description',
  please_enter_en_desc: 'Enter the download english description',
  please_enter_doc: 'Enter the download documentation',
  system_list_online: 'Function Online',
  system_list_adjust: 'Function Change',
  system_list_bug_fix: 'Bug Fixes',
  system_list_upgrade: 'System Upgrade',
  drop_files_desc: '+ Drop files here or ',
  browse: 'browse',
  download_list_fail: 'Failed to query downLoad items list.',
  please_select_one_studio: 'Please select at least one studio.',
  update_whitelist_success: 'Successfully updated Whitelist.',
  update_whitelist_fail: 'Failed to update Whitelist.',
  turn_on: 'Turn on:',
  studio_list: 'Studio List:',
  del_download_sure_desc: 'Are you sure you want to delete the download: ',
  del_news_sure_desc: 'Are you sure you want to delete the news: ',
  del_version_sure_desc: 'Are you sure you want to delete the version: ',

  email_validation_format:
    "It seems like the email you've entered is not in the correct format. Please make sure your email includes '@' symbol and a domain. For example, 'example@example.com'.",
  password_short:
    'Your password is too short. For your security, your password should be at least 14 characters long. Please try again with a longer password.',
  password_not_complexity:
    "Your password doesn't meet the complexity requirements. Please include at least 3 of: uppercase letter, lowercase letter, number, and symbols.",
  account_create_success: 'Account created successfully.',
  account_create_fail: 'Account create failed.',
  create_account: 'Create Account',
  service_create_success: 'Create Service success!',
  service_create_fail: 'Create Service fail!',
  jsonconfig_not_valid: 'JsonConfig is not a valid JSON format.',
  name_format_tips:
    'Name should only contain letters, numbers, underscores, hyphens, and spaces!',
  request_password: 'Request Password',
  refresh_status: 'Refresh Status',
  create_role: 'Create Role',
  request_password_success: 'Request password success!',
  request_password_fail: 'Request password failed!',
  error_same_engine: 'Cannot select same engines.',
  add_engine: '+ Add Engine',
  env_list_fetch_fail: 'Failed to fetch env list',
  number_of_studios: 'Number of studios',
  select_or_search_studio: 'Please select or search for a studio',
  number_of_games: 'Number of games',
  select_or_search_game: 'Please select or search for a game',
  migration: 'Migration',
  migration_org_studio: 'Migration original studio',
  select_org_studio: 'Select original studio',
  migration_tar_studio: 'Migration target studio',
  select_tar_studio: 'Select target studio',
  migration_org_game: 'Migration original game',
  select_org_title: 'Select original title',
  environments_env_length: 'Environments ({{envListLength}})',
  migration_success: 'Migration successfully.',
  migration_temporarily_offline: 'Function temporarily offline',
  migration_fail: 'Migration failed.',
  fail_uid_of_studio:
    'Failed to query the uid of the target studio owner user.',
  migration_title: 'Migration title',
  migrate_game_confirm_admin_desc:
    'Are you sure you want to migrate the title: {{gameName}} ({{gameId}}) to the studio: {{studioName}} ({{studioId}})?',
  copy_success: 'Copy successfully!',
  copy_password: 'Copy Password',
  copy: 'Copy',
  control_account_desc: 'Control Account：InGame_Support@tencent.com',
  control_account: 'Control Account',
  logout_success: 'logout success.',
  logout_user: 'Logout user',
  logout_user_upper: 'Logout User',
  confirm_logout: 'Confirm logout?',
  expiry: 'Expiry',
  refresh_status_success: 'Refresh status success!',
  refresh_status_fail: 'Refresh status failed!',
  create_role_success: 'Create role success!',
  create_role_fail: 'Create role failed!',
  total_search_account_list: 'Total: {{count}}',
  total_merge_user_list: 'Total: {{mergeUserListLength}}',
  query_fail: 'Query failed!',
  sure_close_service_desc:
    'Are you sure you want to close the service for the studio?',
  sure_open_service_desc:
    'Are you sure you want to open the service for the studio?',
  update_service_success: 'Update Service success!',
  update_service_fail: 'Update Service fail!',
  modify_service: 'Modify Service',
  record_copied_to_clipboard: 'The record has been copied to the clipboard.',
  no_data_available: 'No data available',
  add_permission_list: 'Add permission list:\n{{userNamesWithDuration}}',
  remove_permission_list:
    '\nRemove permission list:\n{{userNamesWithNoDuration}}',
  no_list_retry: 'There is currently no list to retry.',
  fail_retrieable_list: 'Failed to obtain retrieable list.',
  retry_success: 'Successfully retried.',
  retry_fail: 'Failed to retry.',
  retry_to_sync: 'Retry to sync',
  wait_for_retry: 'Wait for retry',
  successful_retry: 'Successfully Retried',
  unknown_status: 'Unknown status',
  please_update_content: 'Please enter update content.',
  please_update_zh_content: 'Please enter update chinese content.',
  please_update_en_content: 'Please enter update english content.',
  content_example: '**Content Example**',
  exceed_character_limit: 'Characters exceed the {{maxLength}} limit!',
  operation_success: 'Operation Success!',
  operation_failed_ids: 'Operation failed for ID(s): {{failedIdsString}}',
  operation_failed: 'Operation failed',
  confirm_approve: 'Confirm approve?',
  confirm_reject: 'Confirm reject?',
  confirm_batch_approve: 'Confirm batch approve?',
  confirm_batch_reject: 'Confirm batch reject?',
  approve: 'Approve',
  batch_approve: 'Batch Approve',
  reject: 'Reject',
  batch_reject: 'Batch Reject',
  query_status_success_10:
    'Query user online status success, try again after 10 seconds',
  logout_success_user_id: '({{clickUserID}}) logout success',
  logout_fail_user_id: '({{clickUserID}}) logout failed',
  // 后台菜单
  support_access: 'Support Access',
  studio_management: 'Studio Management',
  app_config: 'APP Config',
  service_manage: 'Service Manage',
  service_online: 'Service Online',
  download_manage: 'Download Management',
  price_management: 'Price Management',
  price_calculator: 'Price Calculator',
  download_news: 'Download Center News',
  gauth_failed: 'Gauth Failed',
  customer_service: 'Customer Service',
  title_manage: 'Title Management',
  game_perm_view: 'Title View',
  game_perm_edit: 'Title Management',
  service_application: 'Service Application',
  message_push: 'Message Push',
  business_notice: 'Business Notice',
  mail_record: 'Contact Us',
  upgrade_notification: 'Upgrade Notification',
  ingame_upgrade_notification: 'InGame Upgrade Notification',
  user_manage: 'User Management',
  user_list: 'User List',
  admin_account: 'Admin Account',
  game_manage: 'Game Manage',
  game_list: 'Title List',
  platform_operation: 'Platform Operation',
  customer_contact: 'Customer Contact',

  email_push: 'Email Push',
  oa_portal_ad: 'OA Portal Ad',
  k_m: 'KM',
  wei_bao: 'Weibao',
  qq_tv: 'QQTV',
  gcloud_oa: 'GCloud OA',
  product_presentation: 'Product Presentation',
  colleague_recommend: 'Colleague Recommend',
  others: 'Others',

  gcloud_intl: 'GCloud-Intl',
  gcloud_chinese: 'GCloud-Chinese',
  social_media: 'Social  Media',
  friend_or_colleague_recommend: 'Friend or Colleague Recommend',

  intl_gcloud_intl: 'GCloud-Intl',
  twitter: 'Twitter',
  facebook: 'Facebook',
  instagram: 'Instagram',
  youtube: 'Youtube',
  gdc: 'GDC',
  friends: 'Friends',
  intl_others: 'Others',

  mail_name: 'Name',
  mail_email: 'Email',
  mail_department: 'Department',
  mail_company: 'Company',
  mail_job_title: 'Job Title',
  mail_status: 'Send Email Status',
  mail_channel: 'How Did You Hear About Us?',
  mail_application: 'Application Time',
  download_record: 'Record',
  download_obj: 'Download',
  download_status: 'Status',
  download_link_info: 'Link Info',
  download_size: 'Download Size',
  download_time: 'Download Time(UTC)',
  download_time_local: 'Download Time',
  user_center: 'User Center',
  website_home: 'Website',
  is_sure_copy_record: 'Are you sure to copy this record?',

  model_name: 'Model Name',
  price_online_status: 'Online',
  price_online: 'online',
  price_offline: 'offline',
  cost_items: 'Cost Items',
  cost_script: 'Cost Script',
  is_sure_delete_model: 'Are you sure you want to delete the Model:',
  please_enter_model_name: 'Please enter model name.',
  please_select_cost_items: 'Please select cost items.',
  please_enter_cost_script: 'Please enter cost script.',
  model_setting: 'Model Setting',

  // 权限中心后台
  group_admin: 'Group',
  object_admin: 'Object',
  permission_manage: 'Permission Manage',
  permission_list: 'Permission List',
  support_permission_list: 'Support Permission List',
  create_group: 'Create Group',
  batch_create_resources: 'Batch Create Resources',
  batch_create_faild: 'Batch creation failed. Please try again',
  del_group_sure_desc: 'Are you sure you want to delete the Group:',
  object: 'Object',
  create_object: 'Create Object',
  edit_object: 'Edit Object',
  delete_object: 'Delete Object',
  del_object_sure_desc: 'Are you sure you want to delete the Object:',
  parentId: 'Parent Id',
  objectGroupId: 'ObjectGroup Id',
  objectGroupName: 'ObjectGroup Name',
  children: 'Children',
  objects: 'Objects',
  objectKey: 'Object Key',
  objectName: 'Object Name',
  expand_all: 'Expand all',
  put_away_all: 'Put away all',

  // 企业认证
  menu_company_auth: 'Enterprise Certificate',
  company_id: '企业ID',
  company_name: '企业名称',
  company_area: '所属地区',
  company_cooper: '合作伙伴',
  company_auth_applier: '申请人',

  // 费用中心后台
  billing_manage: 'Billing Management',
  withdrawal_list: 'Withdrawal List',

  quit: 'Quit',
  quit_title: 'Quit Support',
  quit_body: "Are you sure you don't want to use the Support console anymore?",

  please_select_new_member: 'Select new members',

  // 服务批量审批
  service_approval: 'Service approval',
  title_code_name: 'Title Code Name',
  open_service: 'Services',
  additional_config: 'Additional Config',
  access_layer_deployment: 'Access Layer Deployment',
  bianque_deployment: 'BianQue Deployment',
  report_gateway_deployment: 'ReportGateway Deployment',
  approval_version: 'Version',
  cannot_batch_approval:
    'This service is a separate deployment process and does not support batch approval for the time being.',
  pending_status: 'Pending',
  processing_status: 'Processing',
  resolved_status: 'Resolved',
  rejected_status: 'Rejected',
  admin_apply_service: 'Application Service',
  admin_region: 'Region',
  admin_studio_info: 'Studio Info',
  admin_applicant: 'Applicant',
  admin_applicant_time: 'Application Time',
  admin_modify_time: 'Modify Time',
  admin_approver: 'Approver',
  admin_result: 'Result',
};
